// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__N-k9A","home":"nav_home__XJDHd","projects":"nav_projects__o1tN+","contact":"nav_contact__ltJxC"};